import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tab, Tabs } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserShield } from '@fortawesome/free-solid-svg-icons';
import { TranslationKeys } from '../../../../translations';
import {
  PageWrapperStyled,
  PageHeaderStyled,
  HeaderIconWrapperStyled,
  HeaderTextStyled,
  HeaderTitleStyled,
  HeaderSubtitleStyled,
  TabsContainerStyled,
  FeaturesGridStyled,
} from './AdminPanelManagementPage.styles';
import { CATEGORIES } from './constants';
import { FeatureCard } from './components/FeatureCard';
import { useAdminPanelManagementPage } from './useAdminPanelManagementPage';

// ─── Page ─────────────────────────────────────────────────────────────────────

export const AdminPanelManagementPage = () => {
  const { activeTab, activeCategory, handleTabChange, handleNavigate } = useAdminPanelManagementPage();

  return (
    <PageWrapperStyled>
      {/* Header */}
      <PageHeaderStyled elevation={0}>
        <HeaderIconWrapperStyled>
          <FontAwesomeIcon icon={faUserShield} />
        </HeaderIconWrapperStyled>
        <HeaderTextStyled>
          <HeaderTitleStyled variant="h4">
            <FormattedMessage id={TranslationKeys.adminPanel_header_title} />
          </HeaderTitleStyled>
          <HeaderSubtitleStyled variant="body2">
            <FormattedMessage id={TranslationKeys.adminPanel_header_description} />
          </HeaderSubtitleStyled>
        </HeaderTextStyled>
      </PageHeaderStyled>

      {/* Category tabs + feature grid */}
      <TabsContainerStyled elevation={0}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            borderBottom: theme => `1px solid ${theme.palette.divider}`,
            '& .MuiTab-root': { minHeight: 56, textTransform: 'none', fontWeight: 600, gap: 1 },
          }}
        >
          {CATEGORIES.map((cat, idx) => (
            <Tab
              key={cat.titleId}
              icon={<FontAwesomeIcon icon={cat.tabIcon} style={{ color: cat.color }} />}
              iconPosition="start"
              label={<FormattedMessage id={cat.titleId} />}
            />
          ))}
        </Tabs>

        <FeaturesGridStyled>
          {activeCategory.features.map(feature => (
            <FeatureCard
              key={feature.titleId}
              feature={feature}
              color={activeCategory.color}
              onNavigate={handleNavigate}
            />
          ))}
        </FeaturesGridStyled>
      </TabsContainerStyled>
    </PageWrapperStyled>
  );
};
